<template>
  <div id="modal_faleConosco">
    <transition @enter="enter" @leave="leave">
      <div v-click-outside="onClickOutside" id="principal" v-if="ativarModal">
        <div id="modal_principal" v-if="ativarModal && showNivel1">
          <div class="fale-conosco-header" :class="{ 'pb-5' : showNivel1}" style="align-items: baseline">
            <p class="fonte_padrao_bold" style="top: 20px">Precisa de ajuda?</p>
            <div>
              <CloseIcon class="p-2" :size="36" @click="ativarModal = false" />
            </div>
          </div>
          <div
            class="fale-conosco-body-options"
            :class="{ 'filtered-opt': (searchField || selectedTopic) && !showNivel1}"
          >
            <div class="mt-5" @click="showFAQ()">
              <button class="btn btn-fale-conosco">
                <MagnifyIcon :size="36" />
                <strong> FAQ </strong> - Dúvidas frequentes
              </button>
            </div>
            <a target="_blank" href="https://api.whatsapp.com/send?phone=551130047009" @click="abreLinkwhats()">
              <button class="btn btn-fale-conosco">
                <WhatsappIcon :size="36" />
                <strong> Whatsapp </strong> - Fale com um consultor
              </button>
            </a>
          </div>
        </div>
        <div id="modal_principal" v-if="showFAQ && !showNivel1">
          <div
            class="fale-conosco-header d-flex flex-column"
            style="align-items: baseline"
            :class="{ 'filtered-opt': searchField || selectedTopic }"
          >
            <div
              class="d-flex justify-content-between"
              style="width: 375px; margin-left: -20px; align-items: baseline"
              v-if="!showAnswer"
            >
              <p class="fonte_padrao_bold" style="top: 20px">
                <ChevronLeft
                  class="close-icon"
                  :size="36"
                  @click="backToPrevious()"
                />FAQ
              </p>
              <CloseIcon class="p-2" :size="36" @click="ativarModal = false" />
            </div>
            <div class="search-bar" v-if="!showAnswer">
                <MagnifyIcon class="magnify" :size="28" />
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-model="searchField"
                  placeholder="Como podemos ajudar você?"
                />
            </div>
          </div>
          <div
            class="fale-conosco-body-options"
            :class="{ 'filtered-opt': searchField || selectedTopic }"
          >
            <div
              v-if="showFaqOptions && !searchField"
              class="d-flex flex-column faq-actions"
            >
              <button
                v-for="(item, index) in faq"
                :key="index"
                class="btn topico-ajuda d-flex space-between align-items-center"
                :ripple="false"
                @click="selectTopic(index)"
              >
                <component
                  :size="36"
                  class="m-2 d-flex justify-content-between"
                  :is="item.icon"
                ></component>
                <span class="text-opcao-ajuda">
                  <span class="opcao-label">{{ item.label }}</span>
                </span>
                <button :ripple="false" large icon>
                  <ChevronRight />
                </button>
              </button>
            </div>
          </div>

          <transition name="fade">
            <div
              v-if="showFaqTopic && !searchField"
              class="d-flex flex-column faq-actions"
            >
              <span
                id="topico-selecionado"
                class="topico-ajuda d-flex align-items-center"
                :ripple="false"
              >
                <component
                  :size="36"
                  class="m-2 d-flex justify-content-between"
                  :is="selectedTopic.icon"
                ></component>
                <span class="text-opcao-ajuda">
                  <span class="opcao-label">{{ selectedTopic.label }}</span>
                </span>
              </span>
              <div
                v-for="(item, index) in selectedTopic.content"
                :key="index"
                class="pergunta-ajuda"
                @click="selectQuestion(item)"
              >
                <span class="text-opcao-ajuda">
                  {{ item.question }}
                </span>
                <button :ripple="false" large icon>
                  <ChevronRight />
                </button>
              </div>
            </div>
          </transition>
          <div v-if="searchField" class="d-flex flex-column faq-actions">
            <div class="pergunta-ajuda">
              <span class="text-opcao-ajuda font-weight-bold">Resultados</span>
            </div>
            <div
              v-for="(item, index) in filteredResult"
              :key="index"
              class="pergunta-ajuda"
              @click="selectQuestion(item)"
            >
              <!-- eslint-disable vue/no-v-html-->
              <span class="text-opcao-ajuda" v-html="item.bolderedQuestion">
              </span>
            </div>
          </div>

          <div
            v-if="ativarModal"
            style="
               {
                background-color: rgb(160, 29, 34);
                border-radius: 6px;
              }
            "
          >
            <div class="d-flex align-items-center justify-content-around">
              <p class="answer-title" v-if="faqTitle != 'FAQ'">
                {{ faqTitle }}
              </p>
              <CloseIcon v-if="showAnswer" @click="ativarModal = false" />
            </div>
            <div v-if="showAnswer" class="answer-card">
              <div class="answer-header">
                <button
                  id="answer-back-button"
                  :ripple="false"
                  x-large
                  icon
                  @click="backToAnswers"
                >
                  <ChevronLeft />
                </button>
                <span class="question-title">
                  {{ selectedQuestion.question }}
                </span>
              </div>
              <div class="answer-body">
                <p v-for="p in selectedQuestion.answer.split('\n')" :key="p">{{ p }}</p>
                <div class="tem-mais-duvidas">
                  Tem mais dúvidas? Fale conosco
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="contato_messenger" @click="abreLinkfacebook()">
            <img src="../assets/messenger.svg" alt="imagem_messeger" />
            Fale por Messenger
          </div> -->

      </div>
    </transition>
    <div
      id="faleConosco_chat"
      class="ajuda-faleconosco"
      @click="ativarModal = !ativarModal"
    >
      <p>Ajuda ?</p>
    </div>
    <transition>
      <div
        class="avisoAjuda"
        v-if="ativarAviso"
        :style="{
          'background-image':
            'url(' + require('../assets/aviso-rapido.png') + ')',
        }"
      >
        <p>
          Utilize nosso <span>botão de ajuda</span> a qualquer hora que
          precisar.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

import WhatsappIcon from "vue-material-design-icons/Whatsapp.vue";
import MessageTextIcon from "vue-material-design-icons/MessageText.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import HeartIcon from "vue-material-design-icons/Heart.vue";
import ClipboardTextOutlineIcon from "vue-material-design-icons/ClipboardTextOutline.vue";
import AccountIcon from "vue-material-design-icons/Account.vue";
import USDIcon from "vue-material-design-icons/CurrencyUsd.vue";
import WindowCloseIcon from "vue-material-design-icons/WindowClose.vue";
import WrenchIcon from "vue-material-design-icons/Wrench.vue";

/* eslint-disable vue/no-unused-components */
export default {
  name: "FaleConosco",
  components: {
    WhatsappIcon,
    MessageTextIcon,
    MagnifyIcon,
    CloseIcon,
    ChevronLeft,
    ChevronRight,
    HeartIcon,
    ClipboardTextOutlineIcon,
    AccountIcon,
    USDIcon,
    WindowCloseIcon,
    WrenchIcon,
  },
  /*eslint-disable no-irregular-whitespace*/
  data() {
    return {
      ativarModal: false,
      ativarAviso: false,
      dialog: false,
      showNivel1: true,
      showFaqCard: true,
      showFaqOptions: false,
      showFaqTopic: false,
      selectedTopic: null,
      searchField: null,
      originQuestion: "",
      filteredResult: [],
      selectedQuestion: null,
      faqTitle: "FAQ",
      showSearchField: true,
      showAnswer: false,
      faq: [
        {
          label: "Plano coletivo por adesão",
          icon: "HeartIcon",
          content: [
            {
              question: "O que é um plano coletivo?",
              answer: `São planos pensados para uma coletividade, um grande número de pessoas que possuem alguma característica em comum – os chamados grupos de afinidade. De maneira geral, esses grupos são classificados de acordo com sua categoria profissional, área de atuação ou empresa em que trabalham.\n
              • Planos coletivos por adesão: Plano firmado entre as Associações Profissionais e/ou Entidades de Classe diretamente com a Operadora de Planos de Assistência à Saúde, ou por adesão a contrato firmado entre a Operadora e uma Administradora de Benefícios. Os beneficiários desses planos coletivos devem manter vínculos profissionais, classistas ou setoriais com as Associações Profissionais e/ou Entidades de Classe, podendo assim ser consideradas as Associações, Sindicatos, Caixas de Assistências e Conselhos, nos termos do artigo 9º e incisos da Resolução Normativa nº 195/2009. A adesão a este tipo de plano por parte da população vinculada às Associações Profissionais e/ou Entidades de Classe é espontânea e opcional e o pagamento da mensalidade do plano é de responsabilidade do Beneficiário, sendo que a quitação da fatura junto à Operadora é de responsabilidade da estipulante/contratante.\n
              • Planos coletivos empresariais: Plano firmado entre a Empresa diretamente com a Operadora de Planos de Assistência à Saúde ou por adesão quando ofertado por meio de Administradora de Benefícios. Os beneficiários desses planos coletivos devem manter vínculos com a pessoa jurídica, seja ele, celetista ou estatutário. A oferta pode ser extensiva aos colaboradores inativos, como também aos temporários, quando previsto no rol de beneficiários elegíveis.\n
              No convênio coletivo pode ser observada a estipulação direta por Entidade, mesmo não sendo o indicado, uma que vez a estipulante assume o pagamento da fatura em sua totalidade. No caso dos contratos empresariais, a Pessoa Jurídica pode ter o papel de estipulação e assumir a fatura da operadora e quando ofertado por meio de adesão, somente uma Administradora pode ser realizar a cobrança no nível do beneficiário “titular do plano de saúde”.`,
            },
            {
              question: "O que é entidade de classe?",
              answer: `São organizações que representam os interesses de determinada classe profissional e/ou empresarial. São exemplos de entidades de classe o Conselho Federal de Medicina (CRM), Ordem dos Advogados do Brasil (OAB), Conselho Regional de Administração (CRA) e muitas outras.\n
              A Aliança possui convênio com mais de 200 clientes espalhados por todo o Brasil.  `,
            },
            {
              question:
                "Posso comprar um plano de saúde coletivo sem estar vinculado a uma entidade de classe ou sem possuir vínculo com alguma empresa?",
              answer: `Não, para adquirir um plano coletivo você precisar estar filiado a uma entidade de classe ou possuir vínculo com a empresa para garantir sua elegibilidade.`,
            },
            {
              question:
                "Posso comprar um plano pela Aliança sem ser de funcionário público?",
              answer: `Dispomos de vários convênios e um deles pode trazer a elegibilidade necessária para a contratação de um plano coletivo. Caso tenha alguma dúvida, chame nosso time clicando no botão AJUDA.`,
            },
            {
              question: "Não encontrei o órgão público que eu trabalho?",
              answer: `Se você não identificou seu Órgão na relação de contratos empresariais, selecione na aba profissão Servidor Público para uma oferta coletivo por adesão. Você também pode solicitar o apoio do nosso time clicando no botão AJUDA.`,
            },
          ],
        },
        {
          label: "Planos e coberturas",
          icon: "ClipboardTextOutlineIcon",
          content: [
            {
              question:
                "O que é Declaração Pessoal de Saúde (DPS) ou de Doenças ou Lesões Preexistentes (DLP)?",
              answer: `São perguntas que constam na apólice do seu plano no qual consiste no registro de informações sobre doenças e lesões que saiba ser portador ou sofredor no momento da contratação.`,
            },
            {
              question: "Pra que serve a DPS?",
              answer: `A Declaração de Saúde tem por objetivo resgatar com o beneficiário possíveis doenças ou lesões que saiba ser portador ou sofredor e tenha o conhecimento no momento da contratação (estas classificadas como Doenças e Lesões Preexistentes) para que a Operadora saiba e possa oferecer a Cobertura Parcial temporária (CPT).`,
            },
            {
              question: "Quantos dependentes posso adicionar ao meu plano?",
              answer: `Não há limites para inclusão de dependentes no plano. Porém, deve observar os dependentes passíveis de inclusão, pois temos condições negociadas com as operadoras que permitem inclusão beneficiários, além dos dependentes legais. Em caso de dúvidas pode chamar nosso time de suporte aqui no botão AJUDA.`,
            },
            {
              question: "Quais as diferenças entre os planos recomendados?",
              answer: `De acordo com a informações que você colocou na simulação, recomendamos 3 planos para você, que são considerados: Custo benefício, Rede referenciada, e etc.`,
            },
            {
              question: "O que são Doenças e Lesões Preexistentes?",
              answer: `Doenças ou Lesões Preexistentes (DLP) são aquelas que o beneficiário ou seu representante legal saiba ser portador ou sofredor, no momento da contratação ou adesão ao plano de saúde.`,
            },
            {
              question: "O que é CPT – Cobertura Parcial Temporária?",
              answer: `É o período de suspensão da cobertura de Procedimentos de Alta Complexidade (por exemplo, os que envolvam leitos de alta tecnologia e cirurgias). Esses procedimentos precisam estar relacionados a doenças ou lesões preexistentes informadas pelo beneficiário na Declaração de Saúde (preenchida durante a contratação do plano). O período da suspensão é de até 24 meses ininterruptos, a partir do início da vigência.`,
            },
            {
              question: "O que é vigência do plano de saúde?",
              answer: `É a data em que seu plano começa a “valer”. A partir desta data você e seus dependentes já podem começar a utilizar o plano. Ah, uma informação importante: para alguns procedimentos o prazo de carência deve ser respeitado de acordo com o seu contrato, caso tenha alguma dúvida entre em contato com a sua operadora para mais informações.`,
            },
            {
              question: "Não encontrei o plano da operadora que estou buscando",
              answer: `A Qualicorp trabalha com muitas operadoras e tem uma diversidade grande de produtos. Provavelmente o plano que você estava procurando pode ter saído do portfólio da operadora.`,
            },
            {
              question:
                "Por que a vigência do meu plano não iniciou na data em que assinei a proposta?",
              answer: `Isso acontece porque o seu plano é coletivo por adesão. Nessa modalidade, é necessário realizar a confirmação das informações que você fornece na proposta e depois o envio dos seus dados para a Operadora de Saúde. Essa análise leva um tempo e a data de vigência do seu plano passa a ser a data em que a sua adesão foi aceita pela Operadora.`,
            },
            {
              question: "Qual é o período de cobertura do meu plano?",
              answer: `Na Aliança dispomos vigência 1, ou seja, independente da adesão ou início de cobertura do cliente, sua contratação sempre observará o mês fechado. Porém, a depender da operadora o cliente poderá optar pela vigência flexível, iniciando sua cobertura em até 10 dias de sua adesão. Para consultar maiores informações chame nosso time de suporte no botão AJUDA.`,
            },
            {
              question: "O que é carência?",
              answer: `Carência é um período durante o qual o beneficiário ainda não poderá usufruir de algumas coberturas específicas do seu plano. Esse período precisa ser respeitado até que sejam cumpridos os prazos previstos em contrato, mesmo que você esteja em dia com as mensalidades. É importante observar esses prazos durante a contratação do seu plano, porque eles variam de Operadora para Operadora e de serviços para serviços.`,
            },
            {
              question: "O que é um plano com coparticipação?",
              answer: `Nessa modalidade de plano, você paga uma parte das despesas sempre que realizar consultas, exames, procedimentos e internações. Isso torna as mensalidades do seu plano mais acessíveis.`,
            },
            {
              question: "Por que tenho que pagar a coparticipação?",
              answer: `O pagamento de coparticipação está previsto no seu contrato. Você paga uma parte das despesas sempre que realizar consultas, exames, procedimentos e internações, conforme a tabela de valores e regras da ANS.`,
            },
            {
              question: "Onde encontro meu extrato de coparticipação?",
              answer: `É bem fácil: no site da Aliança, clique na opção Serviço ao Cliente faça seu login ou cadastro, caso seja seu primeiro acesso. Na área logada, clique no menu Financeiro (localizado do lado esquerdo da tela) e, em seguida, nas opções: Pagamento > Extrato de Coparticipação. Prontinho! Se preferir, você também pode acessar seus extratos de coparticipação no App Aliança, também no menu Financeiro.`,
            },
            {
              question: "O que é Portabilidade de carência?",
              answer: `Em observância à RN 438 da ANS, portabilidade de Carências é o direito que o beneficiário tem de mudar de plano de saúde sem a necessidade de cumprimento de períodos de carências ou cobertura parcial temporária. A carência incentiva a manutenção do contrato de plano de saúde mesmo quando o beneficiário não está utilizando, mas dificulta a mudança de plano, na medida em que o beneficiário deverá cumprir carências novamente se quiser contratar outro plano.\n
              O objetivo da portabilidade é permitir que o beneficiário possa mudar de plano sem o cumprimento dos prazos de carência e incentivar a concorrência no mercado. A portabilidade foi baseada na lógica de que o cumprimento de carências pelos beneficiários é realizado no sistema de saúde suplementar e não em uma operadora de planos de saúde.\n
              Vale lembrar que a Portabilidade de Carências se trata de uma adesão a um plano de saúde, porém com a isenção de carências. Portanto, o exercício da portabilidade deverá respeitar todas as regras de contratação. Sendo assim, o beneficiário só poderá realizar a portabilidade de carências para determinado plano se ele tiver elegibilidade, ou seja, se ele puder ingressar nesse plano de acordo com as normas e as regras contratuais.`,
            },
            {
              question: "Quais são os requisitos para realizar a Portabilidade de Carências, nos termos do artigo 3º da RN 438/2018?",
              answer: `• O beneficiário deve estar vinculado a um plano de saúde.\n
              • O beneficiário deve estar em dia com o pagamento da mensalidade junto à operadora do plano de origem.\n
              • O beneficiário deve ter cumprido prazo de permanência, conforme o caso: (1) na primeira portabilidade, deve estar há pelo menos 2 anos na operadora do plano de origem ou há pelo menos 3 anos, se tiver cumprido cobertura parcial temporária (CPT) para doenças e lesões pré-existentes; (2) se o beneficiário ingressou no plano de origem exercendo a Portabilidade de Carências, o prazo mínimo de permanência exigido no plano passa a ser de 1 ano, mas se essa portabilidade foi para um plano com coberturas não previstas na segmentação assistencial do plano de origem, o prazo mínimo a ser cumprido será de 2 anos.\n
              • O plano de origem deve ser regulamentado, ou seja, ter sido contratado após 1° de janeiro de 1999 ou adaptado à Lei n° 9.656/98.\n
              • A faixa de preço do plano de destino deve ser igual ou inferior à que se enquadra o plano de origem do beneficiário, considerada a data da consulta ao módulo de portabilidade de carências do Guia ANS de Planos de Saúde.\n
              • Se o plano de destino for de contratação coletiva, o beneficiário deverá possuir vínculo com a pessoa jurídica contratante do plano, ou o beneficiário deverá ser ou possuir vínculo com empresário individual.`,
            },
            {
              question: "Quando é possível realizar a Portabilidade de Carências?",
              answer: `A portabilidade de carências poderá ser realizada a qualquer tempo pelo beneficiário, após ter cumprido o prazo mínimo de permanência no plano de origem. A operadora não poderá delimitar um período para a realização da portabilidade (janela), se o beneficiário já tiver cumprido o prazo de permanência no plano. A portabilidade de carências deve ser requerida pelo beneficiário antes de ingressar no novo plano. Se o beneficiário aderir a um plano sem se utilizar da portabilidade, caso identifique que tinha direito e venha a solicitar a isenção de carências posteriormente, a operadora não será obrigada a isentar as carências, mesmo se o beneficiário demonstre que tinha esse direito antes de ter aderido ao plano.`,
            },
            {
              question: "Quais são os Documentos necessários para realizar a Portabilidade de Carências?",
              answer: `Para realizar a portabilidade de carências, o beneficiário deverá apresentar os seguintes documentos:\n 
              • Comprovante de que está em dia com o pagamento das mensalidades, tais como: comprovantes de pagamento das 3 (três) últimas mensalidades vencidas, ou declaração da operadora do plano de origem ou da pessoa jurídica contratante.\n
              • Comprovante de prazo de permanência, tais como: proposta de adesão assinada, ou contrato assinado, ou comprovantes de pagamento das mensalidades do prazo de permanência exigido, ou declaração da operadora do plano de origem ou da pessoa jurídica contratante.\n
              • Relatório de compatibilidade entre os planos de origem e de destino ou número de protocolo de portabilidade, ambos emitidos pelo Guia ANS de Planos de Saúde.\n
              • Se o plano de destino for de contratação coletiva, comprovante de vínculo com a pessoa jurídica contratante do plano ou comprovação referente ao empresário individual.\n
              • Se o beneficiário estiver em cumprimento de CPT, deverá apresentar cópia da Declaração de Saúde preenchida no plano de origem ou de documento que ateste que estava cumprindo CPT que especifique a doença ou lesão preexistente declarada. O beneficiário poderá solicitar à operadora do plano de origem, por meio de quaisquer de seus canais de atendimento, a declaração para fins de Portabilidade com as informações referentes ao plano de origem e ao beneficiário. A operadora do plano de origem terá o prazo de 10 (dez) dias para disponibilizar a declaração ao beneficiário. Além dos documentos acima relacionados, a operadora do plano de destino poderá solicitar ao beneficiário os documentos pessoais usualmente requeridos para fins de contratação de planos de saúde, tais como carteira de identidade e comprovante de residência. A exigência de documentos de difícil obtenção pelos beneficiários pode ser interpretada pela ANS como uma tentativa de impedir ou restringir a participação de consumidor em plano privado de assistência à saúde, por ocasião da portabilidade de carências, passível de aplicação de penalidade.`,
            },
            {
              question: "O que é declaração de nascido vivo?",
              answer: `A Declaração de Nascido Vivo (DN), criada em 1990, é documento padronizado pelo Ministério da Saúde (MS) e de uso obrigatório em todo o território nacional para que ocorra o registro civil da criança.`,
            },
            {
              question: "O que é o auxílio saúde?",
              answer: `É o benefício concedido ao servidor público titular de plano de saúde e aos seus dependentes, baseado na remuneração e nas faixas etárias dos servidores e dependentes, segundo tabela publicada pelo Ministério do Planejamento.`,
            },
            {
              question: "Como faço para incluir um dependente no meu plano?",
              answer: `No nosso site na área do cliente você deve entrar com seu login e senha, e logo após clicar em serviços online e em seguida movimentação cadastral, selecione a opção Padrão Aliança Administradora – Assistência Médica ou Odontológica. Gere o formulário, preencha as informações solicitadas, junto com os documento obrigatórios, envie para o e-mail: alteracaocadastral@aliancaadm.com.br`,
            },
            {
              question: "Qual a idade máxima para incluir um dependente?",
              answer: `A Agência Nacional de Saúde Suplementar (ANS) é a responsável por toda a legislação no que diz respeito aos planos de saúde. Assim, segundo as diretrizes desse órgão, para incluir um dependente no seu plano de saúde, ele deve se enquadrar em um dos casos a seguir:\n
              • Cônjuge ou companheiro\n
              • Parente de 1º grau consanguíneo: são os parentes de forma direta, como pais e filhos, ou então pessoas sob a guarda do titular entre os 21 e 24 anos (se forem estudantes e dependentes economicamente do titular).\n 
              Assim, deve ser observado o rol de beneficiários do seu convênio e as condições comerciais que dispomos com diversas operadoras, possibilitando a entrada e permanência dos filhos acima de 21 se não estudantes, como também acima de 24 anos.`,
            },
          ],
        },
        {
          label: "Dados cadastrais",
          icon: "AccountIcon",
          content: [
            {
              question: "Esqueci minha senha. Como posso recuperá-la?",
              answer: `Sim, basta clicar em esqueci minha senha e você será direcionado para registrar uma nova senha`,
            },
            {
              question: "Como faço para atualizar meus dados cadastrais?",
              answer: `Para realizar alteração cadastral você deve entrar em contato com os nossos canais de atendimento através dos telefones  30047010 (capital e regiões metropolitanas) e 0800 603 7007 (demais regiões) ou pelo whatsapp 11 3004 7010.`,
            },
            {
              question: "Como entro em contato com o suporte?",
              answer: `Basta você clicar no botão ajuda e seguir o passo a passo, que nosso time irá te auxiliar.`,
            },
            {
              question: "Como meus dados são protegidos?",
              answer: `Em caso de dúvidas relacionadas à privacidade de dados, consulte o Aviso de Privacidade ou, se preferir, contate-nos via e-mail: privacidade@qualicorp.com.br`,
            },
            {
              question: "Quando poderei usar meu plano?",
              answer: ` você pode utilizar seu plano a partir da data de início da vigência escolhida na proposta, exceto os procedimentos que existem carência pelo operadora.`,
            },
            {
              question: "Não encontrei o plano da operadora que estou buscando?",
              answer: `A Aliança trabalha com muitas operadoras e tem uma diversidade muito grande de produtos, provavelmente o plano que você estava procurando pode ter saído do portfólio da operadora. Acesse nosso chat no botão AJUDA para mais informações.`,
            },
          ],
        },
        {
          label: "Documentação",
          icon: "ClipboardTextOutlineIcon",
          content: [
            {
              question: "Como devo enviar meus documentos após a compra?",
              answer: `Você enviará os documentos de forma online dentro da nossa plataforma de adesão online, basta apenas digitalizar e realizar o upload. Tudo muito simples, rápido e 100% digital`,
            },
            {
              question: "Deu erro ao enviar os documentos, o que fazer?",
              answer: `Nosso time pode te ajudar, basta clicar no botão ajuda dentro da plataforma.`,
            },
            {
              question: "Quanto tempo leva para analisar meus documentos?",
              answer: `Nosso prazo de análise é de 03 dias uteis, caso falte algum documento esse prazo pode ser alterado.`,
            },
            {
              question: "Como serei informado sobre o resultado da análise?",
              answer: `Você irá receber o status da sua proposta via e-mail e SMS, mas, você também pode acompanhar por meio do Serviço ao Cliente aqui em nosso site.`,
            },
            {
              question: "Como posso acompanhar minha compra?",
              answer: `Dentro da área do cliente você terá todo o status da sua proposta, mas também enviaremos via e-mail e SMS.`,
            },
          ],
        },
        {
          label: "Pagamento",
          icon: "USDIcon",
          content: [
            {
              question: "Quais as formas de pagamento?",
              answer: `Sua cobrança pode ser realizada por meio de débito em conta, boleto bancário ou consignação em folha. Verifique as opções disponíveis, pois pode variar de acordo com o convênio.`,
            },
            {
              question: "Posso comprar planos de operadoras diferentes para minha família e pagar um único boleto?",
              answer: `As ofertas aos dependentes observarão o plano escolhido pelo titular, beneficiário elegível, que mantenha vínculo. Assim, não é possível contratar produtos distintos dentro de um mesmo contrato.`,
            },
            {
              question: "Qual a diferença entre o DDA e o Débito Automático?",
              answer: `O Débito Direto Autorizado – DDA é uma forma de pagamento que permite você visualizar diretamente no aplicativo ou sistema do seu banco todos os boletos emitidos em seu CPF. Mas, para que o pagamento aconteça, é necessário que você dê uma autorização todos os meses. Você ganha mais segurança, organização e controle de suas contas.\n
              Já o Débito Automático é um serviço em que é possível automatizar o processo de pagamento das suas contas. Com ele, você tem mais comodidade e garante seus pagamentos em dia.\n
              Para incluir uma conta em débito automático, basta solicitar para a empresa que fornece o serviço e aprovar o débito com o banco.\n        
              Na Aliança, podem se cadastrar correntistas dos seguintes bancos conveniados:\n
              001 – Banco do Brasil*\n
              033 – Santander*\n
              070 – BRB (Banco de Brasília)\n 
              237 – Bradesco\n
              341 – Itaú*\n
              104- Caixa econômica federal\n
              De acordo com a FEBRABAN todos os clientes devem autorizar o débito em conta para que a empresa conveniada realize o débito. Assim, verifique com seu banco o processo para liberação do seu convênio de débito!`,
            },
            {
              question:
                "Por que recebi dois boletos com vencimento no mesmo mês?",
              answer: `Isso pode ter acontecido, porque, após a implantação do seu plano, não houve tempo suficiente para encaminhar a cobrança com a data de vencimento original. Para que você possa se organizar financeiramente, há uma prorrogação da sua primeira cobrança. Fique tranquilo: nos próximos meses, sua cobrança será mantida com vencimento original, de acordo com a sua vigência. Além disso pode acontecer também quando seu plano foi suspenso/cancelado, com reativação posterior gerando cobrança apartada.`,
            },
            {
              question:
                "Posso alterar o vencimento, conforme a data do primeiro boleto?",
              answer: `Infelizmente, isso não é possível. Por ser tratar de contrato coletivo, a data de vencimento já consta em seu contrato.`,
            },
            {
              question:
                "Meu boleto ainda não chegou. Onde consigo a segunda via?",
              answer: `É bem fácil: no site da Qualicorp, clique na opção  Canal do Cliente e faça seu login ou cadastro, caso seja seu primeiro acesso. Na área logada, clique no menu Financeiro (localizado do lado esquerdo da tela) e, em seguida, nas opções: Pagamento > 2ª via de boleto.`,
            },
            {
              question:
                "Como funciona o reajuste de um plano de saúde coletivo por adesão?",
              answer: `Os planos de saúde coletivos podem sofrer 2 tipos de reajuste.\n
              • Anual: É aplicado anualmente, seguindo as regras firmadas entre a operadora de saúde e a administradora do plano. O cliente sempre conta com o apoio da administradora, que negocia junto à operadora de saúde a redução do índice para o menor patamar possível.\n
              • Por Faixa Etária: Reajuste pré-definido contratualmente nas tabelas de preço das operadoras que é aplicado sempre que o titular ou seus dependentes mudam de faixa etária.`,
            },
            {
              question:
                "Meu boleto ainda não chegou, onde consigo a segunda via?",
              answer: `É bem fácil: no site da Aliança, clique na opção Serviço ao Cliente faça seu login ou cadastro, caso seja seu primeiro acesso. Na área logada, clique no menu Financeiro (localizado do lado esquerdo da tela) e, em seguida, nas opções: Pagamento > 2ª via de boleto.`,
            },
          ],
        },
        {
          label: "Cancelamento",
          icon: "WindowCloseIcon",
          content: [
            {
              question:
                "Já tenho um plano, mas quero cancelá-lo e comprar outro. Posso fazer por aqui?",
              answer: `Sim! Basta você escolher o novo produto. Porém, deve estar atento ao início do novo plano e solicitar o cancelamento do plano atual para não realizar o pagamento de duas coberturas.`,
            },
            {
              question: "Como faço se desistir da compra?",
              answer: `Para cancelar uma proposta, você deve acessar a área do ciente e seguir o passo a passo para o cancelamento.\n
              Caso a sua proposta já tenha sido aprovada e o seu plano já esteja ativo, você precisará entrar em contato através dos nossos canais de atendimento 30047010 (capital e regiões metropolitanas) e 0800 603 7007 (demais regiões) ou pelo whatsapp 11 3004 7010 e solicitar o cancelamento.`,
            },
            {
              question: "Tem taxa de cancelamento?",
              answer: ` Não, a Aliança não cobra taxa de cancelamento dos seus clientes.`,
            },
          ],
        },
        {
          label: "Ajuda e suporte",
          icon: "WrenchIcon",
          content: [
            {
              question: "Onde encontro o número do cartão nacional de saúde?",
              answer: `No site https://portaldocidadao.saude.gov.br, o associado pode verificar se o seu número já foi gerado. Basta preencher, sem acento nem cedilha, os campos solicitados no link “Consulta à base de dados do Cartão Nacional de Saúde por nome”.`,
            },
            {
              question: "Onde posso consultar os dados da minha carteirinha?",
              answer: `É bem fácil: no site da Aliança, clique na opção Serviço ao Cliente faça seu login ou cadastro, caso seja seu primeiro acesso. E seguir as orientações dentro do site.`,
            },
          ],
        },
      ],
    };
  },
  watch: {
    searchField() {
      this.filteredResult = [];
      if (this.searchField) {
        const textToFilter = this.searchField.toLowerCase();
        const searchRegExp = new RegExp(textToFilter, "ig");
        for (const topic of this.faq) {
          for (const question of topic.content) {
            if (question.question.toLowerCase().includes(textToFilter)) {
              question.label = topic.label;
              const bolderedQuestion = question.question
                .toString()
                .replace(searchRegExp, (match) => {
                  return "<b>" + match + "</b>";
                });
              question.bolderedQuestion = bolderedQuestion;
              this.filteredResult.push(question);
            }
          }
        }
      }
    },
  },
  created() {
    setTimeout(() => {
      this.ativarAviso = true;
    }, 1000);

    setTimeout(() => {
      this.ativarAviso = false;
    }, 3000);

    window.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)){
          this.showMobileNav = false
        }
      })
  },
  mounted() {
    this.$root.$on("AbreFaleConosco", () => {
      this.ativarModal = true;
    });
  },
  
  methods: {
    fecharmodal() {
      this.ativarModal = false;
    },
    enter() {
      let modalVisivel = document.getElementById("modal_faleConosco");
      modalVisivel.classList.toggle("modal_faleconosco_ativo");
    },
    leave() {
      let modalVisivel = document.getElementById("modal_faleConosco");
      modalVisivel.classList.remove("modal_faleconosco_ativo");
    },
    abreLinkwhats() {
    },
    abreLinkfacebook() {
      window.open("http://m.me/VUE_APP_ALIANCAADM");
    },
    abreLinkConsultores() {
      window.open(
        "https://aliancaadm.com.br/contrate-seu-plano/chame-um-consultor/"
      );
    },

    showFAQ() {
      this.showNivel1 = false;
      setTimeout(() => {
        this.showFaqCard = true;
        this.showFaqOptions = true;
        this.originQuestion = "fromFaqOptions";
      }, 20);
    },
    selectTopic(topicIndex) {
      this.showNivel1 = false;
      setTimeout(() => {
        this.showFaqOptions = false;
        this.showFaqTopic = true;
        this.selectedTopic = this.faq[topicIndex];
        this.originQuestion = "fromSelectedTopic";
      }, 240);
    },
    selectQuestion(question) {
      this.searchField = null;
      if (this.selectedTopic) {
        this.faqTitle = this.selectedTopic.label;
      } else {
        this.faqTitle = question.label;
      }
      this.showFaqTopic = false;
      this.showFaqOptions = false;
      this.showSearchField = false;
      this.showAnswer = true;
      this.selectedQuestion = question;
    },
    closeDialog() {
      this.searchField = null;
      this.showFaqCard = false;
      this.dialog = false;
      this.showFaqOptions = false;
      this.showFaqTopic = false;
      this.showAnswer = false;
      setTimeout(() => {
        this.showNivel1 = true;
        this.showSearchField = true;
        this.faqTitle = "FAQ";
      }, 240);
    },
    backToPrevious() {
      this.searchField = null;
      if (this.showFaqOptions) {
        this.showFaqCard = false;
        this.showFaqOptions = false;
        setTimeout(() => {
          this.showNivel1 = true;
        }, 50);
      } else if (this.showFaqTopic) {
        this.showFaqTopic = false;
        setTimeout(() => {
          this.showFaqOptions = true;
        }, 50);
      }
    },
    backToAnswers() {
      this.showNivel1 = false;
      if (this.originQuestion === "fromSelectedTopic") {
        this.showFaqOptions = false;
        this.showAnswer = false;
        setTimeout(() => {
          this.showFaqTopic = true;
          this.showSearchField = true;
          this.faqTitle = "FAQ";
        }, 0);
      } else if (this.originQuestion === "fromFaqOptions") {
        this.searchField = null;
        this.showFaqTopic = false;
        this.showAnswer = false;
        setTimeout(() => {
          this.showFaqOptions = true;
          this.showSearchField = true;
          this.faqTitle = "FAQ";
        }, 0);
      }
    },
     onClickOutside () {
        this.ativarModal = false;
    }
  },
  directives: {
      clickOutside: vClickOutside.directive
  },
};
</script>

<style scoped src="bootstrap/dist/css/bootstrap.css"></style>
<style lang="scss" scoped>
@import url("../assets/faleConosco.css");
@import url("../assets/styles.css");
</style>